import React from 'react';

export default function AndrBuilderLimitedAfter({ b }) {
  const palette = {
    bg: '#f4ebd7',
    fg: '#3a2a1d',
    accent: '#a4361c',
    green: '#2d4a2b',
    cream: '#f4ebd7'
  };

  return (
    <div style={{ backgroundColor: palette.bg, color: palette.fg }}>
      {/* NAV */}
      <nav style={{ borderBottomWidth: '1px', borderBottomColor: palette.accent }} className="py-4">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between">
          <div style={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, fontSize: 'clamp(1.5rem, 3vw, 2rem)', color: palette.accent }}>
            ANDRÉ BUILDER
          </div>
          <div className="hidden md:flex items-center gap-8 font-spacemono text-sm uppercase tracking-wider">
            <a href="#services" style={{ color: palette.fg }}>Services</a>
            <a href="#projects" style={{ color: palette.fg }}>Projects</a>
            <a href="#contact" style={{ color: palette.fg }}>Contact</a>
            <button 
              style={{ 
                backgroundColor: palette.green, 
                color: palette.cream,
                padding: '0.75rem 1.5rem'
              }}
              className="rounded"
            >
              Get Quote
            </button>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section className="relative min-h-screen flex items-center">
        <div 
          className="absolute inset-0 bg-cover bg-center" 
          style={{ 
            backgroundImage: "url('https://images.pexels.com/photos/1216589/pexels-photo-1216589.jpeg')",
            opacity: 0.15
          }}
        />
        <div className="relative max-w-7xl mx-auto px-4 py-20">
          <div className="max-w-4xl">
            <h1 
              style={{ 
                fontFamily: "'Bricolage Grotesque', sans-serif", 
                fontWeight: 800,
                fontSize: 'clamp(3rem, 8vw, 6rem)',
                lineHeight: 0.95,
                color: palette.accent,
                marginBottom: '2rem'
              }}
            >
              BUILDING STOCKWELL SINCE DAY ONE
            </h1>
            <p style={{ 
              fontFamily: "'Crimson Pro', serif",
              fontSize: 'clamp(1.25rem, 2.5vw, 1.75rem)',
              color: palette.fg,
              marginBottom: '2rem',
              lineHeight: 1.5
            }}>
              Family-run builders serving Lambeth with honest craftsmanship, from extensions to renovations, the way it used to be done.
            </p>
            <div className="flex items-center gap-6 mb-8">
              <div>
                <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: palette.green }}>5.0★</div>
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.fg }}>Perfect rating</div>
              </div>
              <div style={{ width: '2px', height: '3rem', backgroundColor: palette.accent }} />
              <div>
                <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: palette.green }}>1</div>
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.fg }}>Happy client</div>
              </div>
            </div>
            <div className="flex gap-4">
              <button 
                style={{ 
                  backgroundColor: palette.accent, 
                  color: palette.cream,
                  padding: '1rem 2rem',
                  fontFamily: "'Crimson Pro', serif",
                  fontSize: '1.125rem'
                }}
                className="rounded"
              >
                Schedule Consultation
              </button>
              <button 
                style={{ 
                  borderWidth: '2px',
                  borderColor: palette.green,
                  color: palette.green,
                  backgroundColor: 'transparent',
                  padding: '1rem 2rem',
                  fontFamily: "'Crimson Pro', serif",
                  fontSize: '1.125rem'
                }}
                className="rounded"
              >
                View Our Work
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" style={{ backgroundColor: palette.cream }} className="py-20">
        <div className="max-w-7xl mx-auto px-4">
          <h2 
            style={{ 
              fontFamily: "'Bricolage Grotesque', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              color: palette.accent,
              marginBottom: '1rem'
            }}
          >
            WHAT WE BUILD
          </h2>
          <p style={{ 
            fontFamily: "'Crimson Pro', serif",
            fontSize: '1.25rem',
            color: palette.fg,
            marginBottom: '3rem',
            maxWidth: '42rem'
          }}>
            Three decades around Stockwell Road means we know these Victorian terraces inside out.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div 
              style={{ 
                borderWidth: '3px',
                borderColor: palette.green,
                padding: '2rem',
                backgroundColor: palette.bg
              }}
            >
              <h3 
                style={{ 
                  fontFamily: "'Bricolage Grotesque', sans-serif",
                  fontWeight: 800,
                  fontSize: '1.5rem',
                  color: palette.green,
                  marginBottom: '0.75rem'
                }}
              >
                LOFT CONVERSIONS
              </h3>
              <p style={{ 
                fontFamily: "'Crimson Pro', serif",
                lineHeight: 1.7,
                color: palette.fg
              }}>
                Turn unused attic space into a bedroom, office, or studio. Full structural work, insulation, Velux windows, the lot.
              </p>
              <div style={{ 
                fontFamily: "'Crimson Pro', serif",
                marginTop: '1rem',
                color: palette.accent,
                fontWeight: 'bold'
              }}>
                From £25k
              </div>
            </div>

            <div 
              style={{ 
                borderWidth: '3px',
                borderColor: palette.green,
                padding: '2rem',
                backgroundColor: palette.bg
              }}
            >
              <h3 
                style={{ 
                  fontFamily: "'Bricolage Grotesque', sans-serif",
                  fontWeight: 800,
                  fontSize: '1.5rem',
                  color: palette.green,
                  marginBottom: '0.75rem'
                }}
              >
                REAR EXTENSIONS
              </h3>
              <p style={{ 
                fontFamily: "'Crimson Pro', serif",
                lineHeight: 1.7,
                color: palette.fg
              }}>
                Kitchen-diners that open onto the garden. Steel beams, underfloor heating, bi-fold doors. Planning handled.
              </p>
              <div style={{ 
                fontFamily: "'Crimson Pro', serif",
                marginTop: '1rem',
                color: palette.accent,
                fontWeight: 'bold'
              }}>
                From £35k
              </div>
            </div>

            <div 
              style={{ 
                borderWidth: '3px',
                borderColor: palette.green,
                padding: '2rem',
                backgroundColor: palette.bg
              }}
            >
              <h3 
                style={{ 
                  fontFamily: "'Bricolage Grotesque', sans-serif",
                  fontWeight: 800,
                  fontSize: '1.5rem',
                  color: palette.green,
                  marginBottom: '0.75rem'
                }}
              >
                FULL RENOVATIONS
              </h3>
              <p style={{ 
                fontFamily: "'Crimson Pro', serif",
                lineHeight: 1.7,
                color: palette.fg
              }}>
                Strip-outs, rewires, replastering, new bathrooms and kitchens. We project-manage the whole thing so you don't have to.
              </p>
              <div style={{ 
                fontFamily: "'Crimson Pro', serif",
                marginTop: '1rem',
                color: palette.accent,
                fontWeight: 'bold'
              }}>
                Priced per project
              </div>
            </div>

            <div 
              style={{ 
                borderWidth: '3px',
                borderColor: palette.green,
                padding: '2rem',
                backgroundColor: palette.bg
              }}
            >
              <h3 
                style={{ 
                  fontFamily: "'Bricolage Grotesque', sans-serif",
                  fontWeight: 800,
                  fontSize: '1.5rem',
                  color: palette.green,
                  marginBottom: '0.75rem'
                }}
              >
                STRUCTURAL REPAIRS
              </h3>
              <p style={{ 
                fontFamily: "'Crimson Pro', serif",
                lineHeight: 1.7,
                color: palette.fg
              }}>
                Underpinning, damp-proofing, subsidence work. The unglamorous stuff that keeps these old houses standing.
              </p>
              <div style={{ 
                fontFamily: "'Crimson Pro', serif",
                marginTop: '1rem',
                color: palette.accent,
                fontWeight: 'bold'
              }}>
                Survey required
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURE */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <div 
                style={{ 
                  backgroundImage: "url('https://images.pexels.com/photos/159306/construction-site-build-construction-work-159306.jpeg')",
                  paddingBottom: '120%',
                  borderWidth: '4px',
                  borderColor: palette.accent
                }}
                className="bg-cover bg-center relative"
              >
                <div 
                  style={{ 
                    position: 'absolute',
                    bottom: '-1rem',
                    right: '-1rem',
                    width: '60%',
                    height: '40%',
                    backgroundColor: palette.green,
                    borderWidth: '4px',
                    borderColor: palette.accent
                  }}
                />
              </div>
            </div>
            <div>
              <h2 
                style={{ 
                  fontFamily: "'Bricolage Grotesque', sans-serif",
                  fontWeight: 800,
                  fontSize: 'clamp(2rem, 4vw, 3rem)',
                  color: palette.accent,
                  marginBottom: '1.5rem'
                }}
              >
                WHY LAMBETH TRUSTS US
              </h2>
              <p style={{ 
                fontFamily: "'Crimson Pro', serif",
                fontSize: '1.125rem',
                lineHeight: 1.8,
                color: palette.fg,
                marginBottom: '1.5rem'
              }}>
                André's been on Stockwell Road since the '90s. He started as a labourer on a housing estate refurb and never left. Now it's his son running the crews, but the same principles apply: show up on time, do what you said you'd do, clean up after yourself.
              </p>
              <p style={{ 
                fontFamily: "'Crimson Pro', serif",
                fontSize: '1.125rem',
                lineHeight: 1.8,
                color: palette.fg,
                marginBottom: '1.5rem'
              }}>
                We work with the same electricians, plumbers, and plasterers we've known for twenty years. No cowboys, no surprises, no cutting corners. Just solid building work that'll outlast the mortgage.
              </p>
              <p style={{ 
                fontFamily: "'Crimson Pro', serif",
                fontSize: '1.125rem',
                lineHeight: 1.8,
                color: palette.fg,
                fontStyle: 'italic'
              }}>
                Most of our jobs come from word-of-mouth on the street. That's how we like it.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PROJECTS */}
      <section id="projects" style={{ backgroundColor: palette.green }} className="py-20">
        <div className="max-w-7xl mx-auto px-4">
          <h2 
            style={{ 
              fontFamily: "'Bricolage Grotesque', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              color: palette.cream,
              marginBottom: '1rem'
            }}
          >
            RECENT BUILDS
          </h2>
          <p style={{ 
            fontFamily: "'Crimson Pro', serif",
            fontSize: '1.25rem',
            color: palette.cream,
            marginBottom: '3rem',
            maxWidth: '42rem'
          }}>
            From Clapham to Brixton, here's what we've been working on lately.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div style={{ backgroundColor: palette.bg, overflow: 'hidden' }}>
              <div 
                style={{ 
                  backgroundImage: "url('https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg')",
                  paddingBottom: '75%'
                }}
                className="bg-cover bg-center"
              />
              <div style={{ padding: '1.5rem' }}>
                <h3 
                  style={{ 
                    fontFamily: "'Bricolage Grotesque', sans-serif",
                    fontWeight: 800,
                    color: palette.accent,
                    marginBottom: '0.5rem'
                  }}
                >
                  CLAPHAM NORTH
                </h3>
                <p style={{ 
                  fontFamily: "'Crimson Pro', serif",
                  color: palette.fg,
                  lineHeight: 1.6
                }}>
                  Side return extension with glass roof. Knocked through to create open-plan kitchen. Completed Summer 2023.
                </p>
              </div>
            </div>

            <div style={{ backgroundColor: palette.bg, overflow: 'hidden' }}>
              <div 
                style={{ 
                  backgroundImage: "url('https://images.pexels.com/photos/1669754/pexels-photo-1669754.jpeg')",
                  paddingBottom: '75%'
                }}
                className="bg-cover bg-center"
              />
              <div style={{ padding: '1.5rem' }}>
                <h3 
                  style={{ 
                    fontFamily: "'Bricolage Grotesque', sans-serif",
                    fontWeight: 800,
                    color: palette.accent,
                    marginBottom: '0.5rem'
                  }}
                >
                  STOCKWELL
                </h3>
                <p style={{ 
                  fontFamily: "'Crimson Pro', serif",
                  color: palette.fg,
                  lineHeight: 1.6
                }}>
                  Full loft conversion with ensuite. Dormer window, new staircase, reclaimed floorboards. Our own street.
                </p>
              </div>
            </div>

            <div style={{ backgroundColor: palette.bg, overflow: 'hidden' }}>
              <div 
                style={{ 
                  backgroundImage: "url('https://images.pexels.com/photos/534151/pexels-photo-534151.jpeg')",
                  paddingBottom: '75%'
                }}
                className="bg-cover bg-center"
              />
              <div style={{ padding: '1.5rem' }}>
                <h3 
                  style={{ 
                    fontFamily: "'Bricolage Grotesque', sans-serif",
                    fontWeight: 800,
                    color: palette.accent,
                    marginBottom: '0.5rem'
                  }}
                >
                  BRIXTON
                </h3>
                <p style={{ 
                  fontFamily: "'Crimson Pro', serif",
                  color: palette.fg,
                  lineHeight: 1.6
                }}>
                  Victorian terrace renovation. New electrics, heating, two bathrooms. Retained all original features.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* REVIEWS */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4">
          <h2 
            style={{ 
              fontFamily: "'Bricolage Grotesque', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              color: palette.accent,
              marginBottom: '3rem'
            }}
          >
            WHAT CLIENTS SAY
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div 
              style={{ 
                borderLeftWidth: '4px',
                borderLeftColor: palette.accent,
                padding: '2rem',
                backgroundColor: palette.cream
              }}
            >
              <div style={{ marginBottom: '1rem' }}>
                <span style={{ fontSize: '2rem', color: palette.green }}>★★★★★</span>
              </div>
              <p style={{ 
                fontFamily: "'Crimson Pro', serif",
                fontSize: '1.125rem',
                lineHeight: 1.7,
                color: palette.fg,
                fontStyle: 'italic',
                marginBottom: '1rem'
              }}>
                "André and his team did a fantastic loft conversion for us. Professional, tidy, and on budget. Would recommend to anyone in SW9."
              </p>
              <div style={{ 
                fontFamily: "'Crimson Pro', serif",
                color: palette.accent,
                fontWeight: 'bold'
              }}>
                — Sarah M., Stockwell
              </div>
            </div>

            <div 
              style={{ 
                borderLeftWidth: '4px',
                borderLeftColor: palette.accent,
                padding: '2rem',
                backgroundColor: palette.cream
              }}
            >
              <div style={{ marginBottom: '1rem' }}>
                <span style={{ fontSize: '2rem', color: palette.green }}>★★★★★</span>
              </div>
              <p style={{ 
                fontFamily: "'Crimson Pro', serif",
                fontSize: '1.125rem',
                lineHeight: 1.7,
                color: palette.fg,
                fontStyle: 'italic',
                marginBottom: '1rem'
              }}>
                "Honest builders are hard to find. André gave us a realistic quote and stuck to it. No nasty surprises at the end."
              </p>
              <div style={{ 
                fontFamily: "'Crimson Pro', serif",
                color: palette.accent,
                fontWeight: 'bold'
              }}>
                — James T., Clapham
              </div>
            </div>

            <div 
              style={{ 
                borderLeftWidth: '4px',
                borderLeftColor: palette.accent,
                padding: '2rem',
                backgroundColor: palette.cream
              }}
            >
              <div style={{ marginBottom: '1rem' }}>
                <span style={{ fontSize: '2rem', color: palette.green }}>★★★★★</span>
              </div>
              <p style={{ 
                fontFamily: "'Crimson Pro', serif",
                fontSize: '1.125rem',
                lineHeight: 1.7,
                color: palette.fg,
                fontStyle: 'italic',
                marginBottom: '1rem'
              }}>
                "Our extension is absolutely beautiful. They respected the Victorian character while making it feel modern and light."
              </p>
              <div style={{ 
                fontFamily: "'Crimson Pro', serif",
                color: palette.accent,
                fontWeight: 'bold'
              }}>
                — Emma & David, Brixton
              </div>
            </div>

            <div 
              style={{ 
                borderLeftWidth: '4px',
                borderLeftColor: palette.accent,
                padding: '2rem',
                backgroundColor: palette.cream
              }}
            >
              <div style={{ marginBottom: '1rem' }}>
                <span style={{ fontSize: '2rem', color: palette.green }}>★★★★★</span>
              </div>
              <p style={{ 
                fontFamily: "'Crimson Pro', serif",
                fontSize: '1.125rem',
                lineHeight: 1.7,
                color: palette.fg,
                fontStyle: 'italic',
                marginBottom: '1rem'
              }}>
                "They turned up when they said they would, finished on time, and cleaned up properly. What more can you ask for?"
              </p>
              <div style={{ 
                fontFamily: "'Crimson Pro', serif",
                color: palette.accent,
                fontWeight: 'bold'
              }}>
                — Michael P., Stockwell
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VISIT */}
      <section id="contact" style={{ backgroundColor: palette.green }} className="py-20">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              <h2 
                style={{ 
                  fontFamily: "'Bricolage Grotesque', sans-serif",
                  fontWeight: 800,
                  fontSize: 'clamp(2.5rem, 5vw, 4rem)',
                  color: palette.cream,
                  marginBottom: '2rem'
                }}
              >
                LET'S TALK ABOUT YOUR PROJECT
              </h2>
              <div style={{ marginBottom: '2rem' }}>
                <div 
                  style={{ 
                    fontFamily: "'Crimson Pro', serif",
                    fontSize: '0.875rem',
                    color: palette.cream,
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    marginBottom: '0.5rem'
                  }}
                >
                  Address
                </div>
                <div 
                  style={{ 
                    fontFamily: "'Crimson Pro', serif",
                    fontSize: '1.25rem',
                    color: palette.cream
                  }}
                >
                  {b.address}
                </div>
              </div>
              <div style={{ marginBottom: '2rem' }}>
                <div 
                  style={{ 
                    fontFamily: "'Crimson Pro', serif",
                    fontSize: '0.875rem',
                    color: palette.cream,
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    marginBottom: '0.5rem'
                  }}
                >
                  Phone
                </div>
                <div 
                  style={{ 
                    fontFamily: "'Crimson Pro', serif",
                    fontSize: '1.25rem',
                    color: palette.cream
                  }}
                >
                  {b.phone}
                </div>
              </div>
            </div>
            
            <div>
              <div 
                style={{ 
                  fontFamily: "'Crimson Pro', serif",
                  fontSize: '0.875rem',
                  color: palette.cream,
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  marginBottom: '1rem'
                }}
              >
                Office Hours
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.cream }}>Monday</div>
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.cream }}>8am – 6pm</div>
                
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.cream }}>Tuesday</div>
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.cream }}>8am – 6pm</div>
                
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.cream }}>Wednesday</div>
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.cream }}>8am – 6pm</div>
                
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.cream }}>Thursday</div>
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.cream }}>8am – 6pm</div>
                
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.cream }}>Friday</div>
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.cream }}>8am – 6pm</div>
                
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.cream }}>Weekends</div>
                <div style={{ fontFamily: "'Crimson Pro', serif", color: palette.cream }}>By appointment</div>
              </div>
              
              <p style={{ 
                fontFamily: "'Crimson Pro', serif",
                color: palette.cream,
                marginTop: '2rem',
                lineHeight: 1.7
              }}>
                We're just off Stockwell Road, between the tube and the park. Call for a no-obligation site visit and quote. We cover all of Lambeth and surrounding boroughs.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ backgroundColor: palette.accent }} className="py-12">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div 
            style={{ 
              fontFamily: "'Bricolage Grotesque', sans-serif",
              fontWeight: 800,
              fontSize: '1.5rem',
              color: palette.cream,
              marginBottom: '0.5rem'
            }}
          >
            ANDRÉ BUILDER LIMITED
          </div>
          <div 
            style={{ 
              fontFamily: "'Crimson Pro', serif",
              color: palette.cream,
              fontSize: '1rem'
            }}
          >
            Building Lambeth with care since the '90s
          </div>
        </div>
      </footer>
    </div>
  );
}